import { render, staticRenderFns } from "./WorkflowCrumb.vue?vue&type=template&id=63e5c9f8&scoped=true&"
import script from "./WorkflowCrumb.vue?vue&type=script&lang=ts&"
export * from "./WorkflowCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowCrumb.vue?vue&type=style&index=0&id=63e5c9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5c9f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
